import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {closeDrawer} from "../../actions/drawerActions";
import {getQuestionnaireStatistics, getQuestionnaireStatisticsAll} from "../../actions/questionnaireTemplateActions";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import ClickAwayListener from '@mui/material/ClickAwayListener';


const QuestionnaireStatisticsDrawer = (props) => {
    const {
        closeDrawer,
        getQuestionnaireStatisticsAll,
        template,
        templateId,
        statisticsAll,
    } = props;

    // Load statistics data on component mount
    useEffect(() => {
        // There is also a endpoint http://localhost:8081/qd2/api/v1//questionnaire-reference/statistic/{id}
        // this.props.getQuestionnaireStatisticsA(this.props.template.templateId);
        // That will only get the statistics the current published selected id
        // This endpoint gets an array of all published versions by templateKey
        getQuestionnaireStatisticsAll(template.templateKey);
    }, [getQuestionnaireStatisticsAll, template.templateKey]);

    const handleCloseDrawer = () => {
        closeDrawer();
    };

    const formatLine = (lineNum, label, value) => {
        return <div id={"QuestionnaireStatisticsDrawer-Statistics" + lineNum}>
            <div id={"QuestionnaireStatisticsDrawer-Statistics" + lineNum + "a"} style={{height: "15px"}}>&nbsp;</div>
            <div id={"QuestionnaireStatisticsDrawer-Statistics" + lineNum + "b"} style={{display: "flex"}}>
                <div id={"QuestionnaireStatisticsDrawer-Statistics" + lineNum + "c"}
                     style={{paddingLeft: "40px", width: "300px", textAlign: "left"}}>{label}
                </div>
                <div id={"QuestionnaireStatisticsDrawer-Statistics" + lineNum + "d"} style={{textAlign: "left"}}>{value}</div>
            </div>
        </div>
    }


    let statistics = null;
    let surveyCount = 0;
    let unopenedCount = 0;
    let incompleteCount = 0;
    let submittedCount = 0;
    let expiredCount = 0;

    // Loop through all published version statistics load the selected versions stats
    // Sum all the stats
    for (let i = 0; i < statisticsAll.length; i++) {

        surveyCount += statisticsAll[i].surveyCount;
        incompleteCount += statisticsAll[i].incompleteCount;
        submittedCount += statisticsAll[i].submittedCount;
        expiredCount += statisticsAll[i].expiredCount;

        if (statisticsAll[i].qid === templateId) {
            statistics = statisticsAll[i];
        }
    }

    unopenedCount = surveyCount - (incompleteCount + submittedCount + expiredCount);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                handleCloseDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)

        return () => {document.removeEventListener("keydown", handleKeyDown, true)}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
            <ClickAwayListener onClickAway={closeDrawer}>
                <div id="QuestionnaireStatisticsDrawer-container-div1" style={{height: "100%"}}>

                    <ArgoAppBarHook
                        title={"Survey Statistics:"}
                        titleFor={template.name}
                        qualifierFor={template.nameQualifier}
                        showMenuArrowButton="LEFT"
                        onLeftIconButtonTouchTap={closeDrawer}
                        isDrawer={true}
                        width={questionnaireStatisticsDrawerProps.width}
                    />

                    <div id="QuestionnaireStatisticsDrawer-container-div2" style={{height: "100%", overflowX: "hidden"}}>

                        <div style={{height: "20px"}}></div>

                        {(statistics !== null) ?
                            <div>
                                <div id="QuestionnaireStatisticsDrawer-Statistics01"
                                     style={{height: "40px"}}>&nbsp;</div>
                                <div id="QuestionnaireStatisticsDrawer-Statistics02"
                                     style={{height: "40px", paddingLeft: "40px"}}><h2><b>Statistics</b></h2></div>


                                {formatLine("01", "Requested Count", statistics["surveyCount"])}

                                {formatLine("02", "Unopened Count", statistics["surveyCount"] - (statistics["incompleteCount"] + statistics["submittedCount"] + statistics["expiredCount"]))}

                                {formatLine("03", "Open Count", statistics["incompleteCount"])}

                                {formatLine("04", "Submitted Count", statistics["submittedCount"])}

                                {formatLine("05", "Expired Count", statistics["expiredCount"])}

                                {formatLine("06", "Last Requested Date", statistics["lastSent"] === null ? "" : (statistics["lastSent"].substring(5, 7) + "/" + statistics["lastSent"].substring(8, 10) + "/" + statistics["lastSent"].substring(0, 4)))}

                                {formatLine("07", "Last Requested Key", statistics["lastSentKey"] === null ? "" : (statistics["lastSentKey"]))}

                                {formatLine("08", "Last Submitted Date", statistics["lastSubmitted"] === null ? "" : (statistics["lastSubmitted"].substring(5, 7) + "/" + statistics["lastSubmitted"].substring(8, 10) + "/" + statistics["lastSubmitted"].substring(0, 4)))}

                                {formatLine("09", "Last Submitted Key", statistics["lastSubmittedKey"] === null ? "" : (statistics["lastSubmittedKey"]))}


                                <div id="QuestionnaireStatisticsDrawer-Statistics-Versions-01"
                                     style={{height: "40px"}}>&nbsp;</div>
                                <div id="QuestionnaireStatisticsDrawer-Statistics-Versions-02"
                                     style={{height: "40px", paddingLeft: "40px"}}><h2>
                                    <b>{"Statistics Totals for " + props.statisticsAll.length + " Versions"}</b></h2>
                                </div>


                                {formatLine("10", "Requested Count", surveyCount)}

                                {formatLine("11", "Unopened Count", unopenedCount)}

                                {formatLine("12", "Open Count", incompleteCount)}

                                {formatLine("13", "Submitted Count", submittedCount)}

                                {formatLine("14", "Expired Count", expiredCount)}

                            </div>
                            :
                            <div></div>
                        }

                    </div>
                </div>
            </ClickAwayListener>
        );
};


QuestionnaireStatisticsDrawer.defaultProps = {
    close: () => {
    }
};


QuestionnaireStatisticsDrawer.propTypes = {
    closeDrawer: PropTypes.func,
    templateId: PropTypes.number,
    templateKey: PropTypes.string,
    template: PropTypes.object,
    login: PropTypes.object,
};


function mapStateToProps(state, props) {
    return {
        statistics: state.statistics,
        statisticsAll: state.statisticsAll,
        template: state.openCloseSecondaryDrawer.template,
        login: state.login
    };
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDrawer,
        getQuestionnaireStatistics,
        getQuestionnaireStatisticsAll
    }, dispatch);
}


const questionnaireStatisticsDrawerProps = {
    opensecondary: true,
    width: "50%",
    docked: false,
    anchor: "right"
};


export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireStatisticsDrawer);
export {questionnaireStatisticsDrawerProps};
